export default __webpack_public_path__ + "static/media/header_books.1b57ab7d.webp";